import { updateLayer } from '@gonfalon/openapi/operations/updateLayer';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createMutationHook } from '../internal/createMutationHook';
import { layers } from '../queries/layers';

export const useUpdateLayer = createMutationHook(updateLayer, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await queryClient.invalidateQueries({ queryKey: layers.list._def });
  },
});
